/**
 * @generated SignedSource<<67de290ee8a96d7df821218f230c1532>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedResultContainer_buyPage$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly item: {
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_item">;
      } | null;
    } | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedItemTrackingProvider_buyPage" | "SharedItemTile_itemSearch">;
  readonly " $fragmentType": "BuySharedResultContainer_buyPage";
};
export type BuySharedResultContainer_buyPage$key = {
  readonly " $data"?: BuySharedResultContainer_buyPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedResultContainer_buyPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedResultContainer_buyPage",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_itemSearch"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSearchQueryEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemSearchResult",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "item",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "priceBookName",
                      "variableName": "priceBookName"
                    },
                    {
                      "kind": "Variable",
                      "name": "userCountryCode",
                      "variableName": "userCountryCode"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "SharedItemTile_item"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuySharedItemTrackingProvider_buyPage"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "3e17bffde7cf5570995c8c0d416d39bb";

export default node;
